import {GridResponse, ExportRequestType, postWithAuth} from '@/api'
import { POSAmexTransactionResponseType, POSAmexTransactionRequestType } from '@/types/transactions'

export const getPOSAmexTransactions = (request: POSAmexTransactionRequestType) =>
    postWithAuth<GridResponse<POSAmexTransactionResponseType>>('/oppapi/v1/pos/amex-transactions', request)

export const exportPOSAmexTransactions = (params: ExportRequestType<POSAmexTransactionRequestType>) =>
    postWithAuth('/oppapi/v1/pos/amex-transactions/export', params)
    
